import { render, staticRenderFns } from "./PageImageResource.vue?vue&type=template&id=84cdd7f6&scoped=true"
import script from "./PageImageResource.vue?vue&type=script&lang=js"
export * from "./PageImageResource.vue?vue&type=script&lang=js"
import style0 from "./PageImageResource.vue?vue&type=style&index=0&id=84cdd7f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cdd7f6",
  null
  
)

export default component.exports